export const theme = {
  colors: {
    white: "#FFFFFF",
    red: "#BE1622",
    dark: "#292929",
    black: "#000",
    grey1: "#d9d9d9",
    green: "#27ae60",
  },
  fontSize: {
    xxl: "48px",
    xl: "24px",
    l: "20px",
    m: "16px",
    s: "14px",
  },
};
